import { assetPath } from 'sly/lib/path';
import { Button } from 'sly/system';

const CALENDER_LINK_STEPHEN = 'https://calendar.app.google/LPKg11bYP99eDvLu8';
const CALENDER_LINK_CHRISTINE = 'https://calendar.app.google/fqUkTqFeBrJU6AdC7';
const TYPEFORM_LINK = 'https://seniorly.typeform.com/businesspartner';

const enterpriseSolutions = {
  title: 'Seniorly Enterprise Suite',
  description:
    'Our tools and platforms empower you to guide your clients seamlessly through senior living discovery while unlocking new revenue streams for your business.',
  solutions: [
    {
      heading: 'White Label Marketplace',
      description:
        'Our configurable solution delivers a turnkey senior living directory to your domain - or use our marketplace API to funnel data to your CMS. Either way, you’ll have access to the most comprehensive data on senior living communities in the U.S.',
      image: {
        src: assetPath(
          'uploads/react-assets/providers/White Label Marketplace.png'
        ),
      },
    },
    {
      heading: 'Seniorly Navigator',
      description:
        'Seniorly’s powerful guidance tools make it easy for any professional who works with older adults to deliver senior living guidance and community recommendations with confidence. We can help your teams increase service for your clients and revenue for your business.',
      image: {
        src: assetPath('uploads/react-assets/providers/Seniorly Navigator.png'),
      },
    },
    {
      heading: 'Seniorly Academy',
      description:
        'On-demand videos, webinars and bootcamps educate your workforce on the senior living landscape. From care types to intake, we’ll make sure they’re ready to support senior living discovery and decision. Help your team get ready for the silver wave.',
      image: {
        src: assetPath(
          'uploads/react-assets/providers/Seniorly Academy (1).png '
        ),
      },
    },
  ],
};

const conciergeSolutions = {
  title: 'Seniorly Concierge',
  description:
    'We created Seniorly Concierge for family offices, EAP’s and any other business that demands elevated experiences for high-value clients.',
  solutions: [
    {
      description:
        'Our white-glove service provides in-depth senior care consultations, curates perfect community and home care matches, and manages downsizing and moves with ease. Seniorly Concierge delivers the truly personalized care your clients demand while ensuring connection to your team and brand.',
      image: {
        src: assetPath(
          'uploads/react-assets/providers/White-glove care advisory service.png'
        ),
      },
      ItemList: [
        {
          icon: 'BestCare',
          text: 'Care advisory services',
        },
        {
          icon: 'HomeSmallStroke',
          text: 'Downsizing',
        },
        {
          icon: 'Business',
          text: 'Real estate coordination',
        },
        {
          icon: 'MoveIn',
          text: 'Move management',
        },
      ],
    },
  ],
};

const affiliateSolutions = {
  title: 'Seniorly Affiliate',
  description:
    'The Seniorly affiliate program helps any business that works with older adults to better monetize their traffic and leads. We make collaboration simple and easy.',
  solutions: [
    {
      heading: 'Step 1: Refer your clients',
      description:
        'Our senior living advisors are truly local and can support your client with just about any aspect of senior care.\n\nSend us our referrals via email, use our forms, or connect via our API. We make it easy to refer families.',
      image: {
        src: assetPath('uploads/react-assets/providers/Refer your clients.png'),
      },
    },
    {
      heading: 'Step 2: Earn referral fees',
      description:
        'Our dedicated advisors provide personalized support from initial consultation to move-in day, ensuring a seamless experience for your clients.\n\nAnd we keep you informed with real-time progress updates. Receive regular reports tailored to your preferences, track pipeline activity, and watch as your referrals find their ideal senior living community.',
      image: {
        src: assetPath('uploads/react-assets/providers/Earn.png'),
      },
    },
  ],
};

const referralSolutions = {
  // title: 'Seniorly Referral partner program',
  // description:
  //   'Our modern approach to search has helped partner communities grow their move-in volume exponentially. With easy integration and no up-front costs, you can start growing from day one.',
  solutions: [
    {
      heading: 'CareScout Quality Network',
      description: (
        <>
          The CareScout Quality Network is the first-ever vetting system for
          long-term care providers. We created it to make the search for quality
          care simpler and more transparent for families. <br /> <br /> Our
          network partners have all undergone a rigorous, multi-point evaluation
          that assesses their credentials, business practices, and commitment to
          person-centered care. When you&apos;re a part of the network, families
          know you&apos;ve already met a high standard for quality. <br />{' '}
          <br />
          If you&apos;re ready to stand out and work with families who already
          trust your quality, let&apos;s talk.
          <Button to='https://partners.carescout.com/providers' target='_blank'>
            Let&apos;s talk
          </Button>
        </>
      ),
      image: {
        src: assetPath('uploads/react-assets/cqn-badge.png'),
      },
    },
    {
      heading: 'Seniorly Referral Partner Program',
      description: (
        <>
          Our modern approach to senior living search has helped partner
          communities grow their move-in volume exponentially. We do this by
          combining a number of powerful tools:
          <ul className='my-4 ml-6 list-disc'>
            <li>
              <strong>Qualified Leads:</strong> Our advanced technology and
              algorithms match motivated families directly with the right senior
              living communities.
            </li>
            <li>
              <strong>Automated Nurture Programs:</strong> Automated email and
              text programs keep leads engaged and your sales teams informed
              every step of the way.
            </li>
            <li>
              <strong>Truly Local Support:</strong> Our network of local senior
              living advisors work hand-in-hand with your team to build trust
              and confidence in your community.
            </li>
          </ul>
          With easy integration and no up-front costs, you can start growing
          from day one.
          <Button
            className='mt-2'
            to='https://seniorly.typeform.com/businesspartner?typeform-source=www.seniorly.com'
            target='_blank'
          >
            Learn more
          </Button>
        </>
      ),
      image: {
        src: assetPath('uploads/react-assets/providers/qualifiedLeads.png'),
      },
    },
    {
      heading: 'Claim your Community',
      description: (
        <>
          Stand out in a crowded market. Our platform allows you to showcase
          your community to more than 5 million families looking for senior
          living options. With powerful tools to manage your information and
          connect directly with potential residents, we make it easy to grow.
          <Button className='mt-2' to='/providers' target='_blank'>
            Claim your community
          </Button>
        </>
      ),
      image: {
        src: assetPath('uploads/react-assets/amenities-screenshot.png'),
      },
    },
    {
      heading: 'Turnkey integration',
      description:
        'Seniorly integrates seamlessly with most major CRM systems, streamlining data flow and optimizing your workflow. No matter your existing system, we offer a smooth onboarding process and hassle-free integration. Don’t see your CRM? Just ask!',
      image: {
        src: assetPath(
          'uploads/react-assets/providers/Turnkey integration.png'
        ),
      },
    },
  ],
};

const conversionSolutions = {
  title: 'Seniorly Conversion Suite',
  description: `Our conversion tools were built for senior living, not just any industry. They're battle-tested with our own users to tackle today’s toughest conversion challenges - all in a delightfully modern way.`,
  solutions: [
    {
      heading: 'Seniorly Virtual Advisor',
      description:
        'Unlike generic chatbots, the Seniorly Virtual Advisor understands senior living and care, handling open-ended questions about your specific communities and general care with ease.',
      image: {
        src: assetPath('uploads/react-assets/providers/Frame 16907 (4).png'),
      },
      ItemList: [
        {
          icon: 'BestCare',
          text: 'Optimized to handle open-ended questions about your specific communities and general care',
        },
        {
          icon: 'Arts',
          text: 'Customize the chatbot colors to match your brand',
        },
        {
          icon: 'Calendar',
          text: 'Allows families to request pricing, tours, and ask questions',
        },
      ],
      banner: {
        icon: 'Trend',
        text: 'Boost your tour rate by 20%',
      },
    },
    {
      heading: 'Instaconnect',
      description:
        'Cut outreach time by 67% with Instaconnect, the tool we built for our own advisors. Engage leads quickly and efficiently, and write all communications to your own CRM.',
      image: {
        src: assetPath('uploads/react-assets/providers/Instaconnect.png'),
      },
    },
    {
      heading: 'Forms that perform ',
      description:
        'Our forms balance conversion to lead with financial and care type qualification, while our sophisticated routing system delivers the right lead to the right sales team in your organization.',
      image: {
        src: assetPath('uploads/react-assets/providers/Forms that perform.png'),
      },
    },
  ],
};

const realEstateSolutions = {
  title: 'For Real Estate Professionals',
  solutions: [
    {
      heading: 'Unlock home seller leads with Seniorly Real Estate Network',
      description:
        '67% of older adults will fund the transition to senior living through the sale of a home. And no one partners with realtors better than Seniorly, the senior living referral company that puts our families first.',
      image: {
        src: assetPath(
          'uploads/react-assets/providers/d30eb91771470c345841697266f83861.png'
        ),
      },
      cta: {
        text: 'Learn more',
        link: '/partners/real-estate-network',
        eventProps: {
          text: 'real-estate',
          location: 'B2B senior-adjacent industries',
        },
      },
    },
  ],
};

const financialSolutions = {
  title: 'For Financial Advisors',
  solutions: [
    {
      heading: 'Deliver more value to your clients',
      description: `At Seniorly, we help financial advisors become a trusted resource for clients going through one of life's biggest transitions. With our in-depth knowledge of senior living, you can provide real value and become the go-to person they'll turn to - again and again.`,
      image: {
        src: assetPath(
          'uploads/react-assets/providers/9a010e67dced9c7615defb40bdad43e1.png'
        ),
      },
      cta: {
        text: 'Learn more',
        link: '/partners/financial-advisor-network',
        eventProps: {
          text: 'financial-advisor',
          location: 'B2B senior-adjacent industries',
        },
      },
    },
  ],
};

const eapSolutions = {
  title: 'For Employee Programs & Benefits Providers',
  solutions: [
    {
      heading: 'For Employee Programs & Benefits Providers',
      description: `Nearly 1 in 4 employees struggle with the burden of care management or caregiving for an older adult. Seniorly offers professional care and housing navigation that alleviates this burden, saving your staff countless hours and reducing stress. By partnering with us, you'll see decreased absenteeism, improved job performance, and a more supported, productive workforce. Invest in your employees' well-being with Seniorly.`,
      image: {
        src: assetPath(`uploads/react-assets/providers/eap.png`),
      },
      cta: {
        text: 'Learn more',
        link: '/partners/employee-assistance-programs',
        eventProps: {
          text: 'employee-assistance-programs',
          location: 'B2B senior-adjacent industries',
        },
      },
    },
  ],
};

export {
  affiliateSolutions,
  CALENDER_LINK_CHRISTINE,
  CALENDER_LINK_STEPHEN,
  conciergeSolutions,
  conversionSolutions,
  eapSolutions,
  enterpriseSolutions,
  financialSolutions,
  realEstateSolutions,
  referralSolutions,
  TYPEFORM_LINK,
};
